import { create } from "zustand";

export interface IUserInfo {
	first_name: string;
	last_name: string;
	token: string;
	role: string;
}

interface StateProps {
	accessToken: string;
	activeLanguage: string;
	isLoggedIn: boolean;
	setAccessToken: (value: string) => void;
	setActiveLanguage: (value: string) => void;
	setIsLoggedIn: (value: boolean) => void;
	userInfo: IUserInfo | null;
	setUserInfo: (info: IUserInfo) => void;
	updateUserInfo: (partialInfo: Partial<IUserInfo>) => void;
	loadUserInfo: () => IUserInfo | null;
	clearUserInfo: () => void;
}

const useStore = create<StateProps>((set, get) => ({
	accessToken: "",
	activeLanguage: "",
	isLoggedIn: false,
	userInfo: null,
	setUserInfo: (info) => {
		try {
			set({ userInfo: info });
			localStorage.setItem("userInfo", JSON.stringify(info));
		} catch (error) {
			console.error("Failed to store userInfo:", error);
		}
	},
	updateUserInfo: (partialInfo) => {
		try {
			const currentInfo = get().userInfo;
			if (!currentInfo) return;

			const updatedInfo = { ...currentInfo, ...partialInfo };
			set({ userInfo: updatedInfo });
			localStorage.setItem("userInfo", JSON.stringify(updatedInfo));
		} catch (error) {
			console.error("Failed to update userInfo:", error);
		}
	},

	loadUserInfo: () => {
		try {
			const storedInfo = localStorage.getItem("userInfo");
			if (storedInfo) {
				const parsed = JSON.parse(storedInfo);
				set({ userInfo: parsed });
				return parsed;
			}
			return null;
		} catch (error) {
			console.error("Failed to load userInfo:", error);
			return null;
		}
	},

	clearUserInfo: () => {
		try {
			localStorage.removeItem("userInfo");
			set({ userInfo: null });
		} catch (error) {
			console.error("Failed to clear userInfo:", error);
		}
	},

	setAccessToken: (value: string) => {
		set({ accessToken: value, isLoggedIn: !!value });
		localStorage.setItem("accessToken", value);
	},

	setActiveLanguage: (value: string) => {
		set({ activeLanguage: value });
		localStorage.setItem("activeLanguage", value);
	},

	setIsLoggedIn: (value: boolean) => {
		set({ isLoggedIn: value });
	},
}));

export default useStore;
